import { render, staticRenderFns } from "./IdeasList.vue?vue&type=template&id=3b730c7b"
import script from "./IdeasList.vue?vue&type=script&lang=js"
export * from "./IdeasList.vue?vue&type=script&lang=js"
import style0 from "./IdeasList.vue?vue&type=style&index=0&id=3b730c7b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports